module.exports = __webpack_public_path__ + "img/status_-1.9fe2d969.png";